module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAMAAACtdX32AAAAjVBMVEUAOKgBOKgGPaoINqQfOJskQqMmVrUnOJYoV7Y4Yrk6Y7lDbL9Ebb9Hb8BIcMFYSpSIHlKPHU6QHU2QaJiQaJmlGUCnuuG5yOe6yefGjKTOESbPGCzQHDDSJjrVM0XVNUfXO0zZRFXZTFzZY3LZZ3bcV2bfZHLjeoXoj5nrn6jtp6/zxcr44OL54eT///9qwhsZAAAAg0lEQVR42sXJRxKCUBBF0SaJGQygPPhE+WT3vzxTObG7HOoZ3apL16/+vzNAayDjO7w7KRRtW0Cdww/0sIoxjeOEeE2SbZLrrtN5shH3PK37YejrdCZuswSaBihNEkXBznH2QUSyhWsZhuUu+fGfDjaRffQZwkvleRdw9A6lIG7mZ/sGeKg8DoeW6hkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/sk.png
// module id = 926
// module chunks = 0